import Vue from 'vue'
import router from '../router'
import axios from 'axios'

const host = process.env.VUE_APP_API_SERVER

const routes = {
  paises: host + '/api/admin/country',
  regiones: host + '/api/admin/geographicArea',
  direcciones: host + '/api/admin/address',
  departamentos: host + '/api/admin/department',
  ubicaciones: host + '/api/admin/location',
  notificaciones: host + '/api/admin/notification',
  empleados: host + '/api/admin/employee',
  instructores: host + '/api/admin/instructor',
  eventos: host + '/api/admin/event',
  reportes: host + '/api/admin/report',
  permisos: host + '/api/admin/permissions',
  roles: host + '/api/admin/roles',
  permisos_rol: host + '/api/admin/roles/readPermissions',
  asignar_permiso: host + '/api/admin/roles/assignPermission',
  recursos: host + '/api/admin/resources',
  permiso_recursos: host + '/api/admin/permissions/readResources',
  asignar_recursos: host + '/api/admin/permissions/assignResource',
  eventos: host + '/api/admin/event',
}

const modules = {
  'catalogues': 'CATALOGOS',
  'employees': 'EMPLEADOS',
  'instructors': 'INSTRUCTORES',
  'events': 'EVENTOS',
  'reports': 'REPORTES',
  'roles': 'ROLES',
  'permissions': 'PERMISOS',
  'resources': 'RECURSOS',
}

export default {
  ws: function (method, name, data, type, file) {
    let isOnline = navigator.onLine
    if (method === 'get' && type == 'url') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        return axios.get(routes[name] + '/' + data, { headers })
          .then(response => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch(error => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return { ok: false, code: error.response.data.code, message: error.response.data.message }
            }
          })
      } else {
        router.push('/login')
      }
    }
    else if (method === 'get' && (type == 'params' || type === undefined)) {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        let params = ''
        for (let k in data) {
          if (k != 'idestado_incan') {
            params += k + '=' + data[k] + '&'
          }
          else {
            params += k + '=' + data[k]
          }
        }
        params = (params !== '') ? '?' + params : ''
        return axios.get(routes[name] + params, { headers })
          .then(response => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch(error => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return { ok: false, code: error.response.data.code, message: error.response.data.message }
            }
          })
      } else {
        router.push('/login')
      }
    }
    else if (method === 'post') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        return axios.post(routes[name], data, { headers })
          .then(response => {
            let res = response.data
            return { ok: true, data: res.data }

          })
          .catch(error => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return { ok: false, code: error.response.data.code, message: error.response.data.message }
            }
          })
      } else {
        router.push('/login')
      }
    }
    else if (method === 'put') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Authorization': 'Bearer ' + jwt
        }
        return axios.put(routes[name], data, { headers })
          .then(response => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch(error => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return { ok: false, code: error.response.data.code, message: error.response.data.message }
            }
          })
      } else {
        router.push('/login')
      }
    }
    else if (method === 'putFile') {
      if (Vue.prototype.$session.exists()) {
        let dataFile = new FormData();
        let fileInfo = file;
        dataFile.append('file', fileInfo);
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + jwt
        }
        return axios.put(routes[name] + '/' + data + routes[type], dataFile, { headers })
          .then(response => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch(error => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return { ok: false, code: error.response.data.code, message: error.response.data.message, line: error.response.data.data.line }
            }
          })
      } else {
        router.push('/login')
      }
    }
    else if (method === 'delete') {
      if (type == 'url') {
        if (Vue.prototype.$session.exists()) {
          let jwt = Vue.prototype.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.delete(routes[name] + '/' + data, { headers })
            .then(response => {
              let res = response.data
              return { ok: true, data: res.data }
            })
            .catch(error => {
              if (!isOnline) {
                return { ok: false, code: 'INTERNET_DISCONNECTED' }
              } else {
                return { ok: false, code: error.response.data.code, message: error.response.data.message }
              }
            })
        } else {
          router.push('/login')
        }
      } else {
        if (Vue.prototype.$session.exists()) {
          let jwt = Vue.prototype.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.delete(routes[name], { headers, data })
            .then(response => {
              let res = response.data
              return { ok: true, data: res.data }
            })
            .catch(error => {
              if (!isOnline) {
                return { ok: false, code: 'INTERNET_DISCONNECTED' }
              } else {
                return { ok: false, code: error.response.data.code, message: error.response.data.message }
              }
            })
        } else {
          router.push('/login')
        }
      }
    }

  },
  check(option, path) {
    path = path.split('/')
    path = path[path.length - 1]
    let key = modules[path]
    if (option === 1) {
      key += '_LECTURA'
    }
    else if (option === 2) {
      key += '_ESCRITURA'
    }
    else if (option === 3) {
      key += '_ELIMINAR'
    }
    else {
      return false
    }
    let permisos = Vue.prototype.$session.get('permisos')
    if (permisos.indexOf(key) >= 0) {
      return true
    }
    else {
      return false
    }
  },
  menu(path) {
    let ele = path.split('/').pop()
    if (ele in modules) {
      let key = modules[ele]
      key += '_LECTURA'
      let permisos = Vue.prototype.$session.get('permisos')
      if (permisos.indexOf(key) >= 0) {
        return true
      }
      else {
        return false
      }
    }
    else {
      return false
    }
  },
  routes
}
